import {DxGridRow} from "../../dx-grid/domain/dx-grid-row";
import {jsonMember, jsonObject} from "typedjson";
import {PitFinancingItem} from "./pit-financing-item";
import {PitSourceActivityVersion} from "./pit-source-activity-version";
import {PitFinancingRedistribution} from "./pit-financing-redistribution";
import {
  IPitFinancingRedistributionBySourceLite
} from "./pit-financing-redistribution-by-source-lite";
import {DxCoreUtils} from "../../dx-core/utiles/dx-core-utils";


@jsonObject
export class PitFinancingRedistributionBySource extends DxGridRow implements IPitFinancingRedistributionBySourceLite {

  /** Уникальный идентификатор строки перераспределения финансирования между мероприятиями по источникам */
  @jsonMember({name: "id", constructor: Number, emitDefaultValue: false, isRequired: false })
  _id: number;

  /** Год финансирования */
  @jsonMember({name: "year", constructor: Number, emitDefaultValue: false, isRequired: false })
  _year: number;

  /** Сумма финансирования по мероприятию «донору», которая потенциальна может быть перераспределена */
  @jsonMember({name: "activityFinancingCanRedistribute", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _activityFinancingCanRedistribute: number;

  /** Сумма резерва финансирования по мероприятию «донору» на другие мероприятия */
  @jsonMember({name: "activityFinancingRedistributeReserve", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _activityFinancingRedistributeReserve: number;

  /** Сумма финансирования по мероприятию «донору» */
  @jsonMember({name: "activityFinancingSum", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _activityFinancingSum: number;

  /** Сумма финансирования по мероприятию «донору» после выполнения перераспределения */
  @jsonMember({name: "activityFinancingFinishSum", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _activityFinancingFinishSum: number;

  /** Сумма перераспределения */
  @jsonMember({name: "redistributionSum", constructor: Number, emitDefaultValue: false, preserveNull: false, isRequired: false })
  private _redistributionSum: number = 0;

  /** Код бюджетной классификации */
  @jsonMember({name: "financingItem", constructor: PitFinancingItem, emitDefaultValue: false, isRequired: false })
  private _financingItem: PitFinancingItem;

  /** Код бюджетной классификации статьи «донора» */
  @jsonMember({name: "financingItemSrc", constructor: PitFinancingItem, emitDefaultValue: false, isRequired: false })
  private _financingItemSrc: PitFinancingItem;

  @jsonMember({constructor: Number, emitDefaultValue: false, isRequired: false })
  get financingItemId(): number {
    return this._financingItem ? this._financingItem.id : null;
  }

  @jsonMember({constructor: Number, emitDefaultValue: false, isRequired: false })
  get financingItemSrcId(): number {
    return this._financingItemSrc ? this._financingItemSrc.id : null;
  }

  /** Версия мероприятия «донора» */
  @jsonMember({name: "activityVersion", constructor: PitSourceActivityVersion, emitDefaultValue: false, isRequired: false })
  private _activityVersion: PitSourceActivityVersion;


  public redistribution: PitFinancingRedistribution;


  private _fakeId = DxCoreUtils.randomHexaDecimal();

  get id(): any {
    return this._id ? this._id : this._fakeId;
  }

  set id(value: any) {
    this._id = value;
  }

  get isNew(): boolean {
    return this.id !== this._id;
  }

  getRowId(): any {
    return this.id;
  }

  get year(): number {
    return this._year;
  }

  get activityFinancingCanRedistribute(): number {
    return this._activityFinancingCanRedistribute;
  }

  get activityFinancingRedistributeReserve(): number {
    return this._activityFinancingRedistributeReserve;
  }

  get activityFinancingSum(): number {
    return this._activityFinancingSum;
  }

  get financingItem(): PitFinancingItem {
    return this._financingItem;
  }

  get financingItemSrc(): PitFinancingItem {
    return this._financingItemSrc;
  }

  set financingItemSrc(value: PitFinancingItem) {
    this._financingItemSrc = value;
  }

  get activityVersion(): PitSourceActivityVersion {
    return this._activityVersion;
  }

  get kadmCode(): string {
    return this._financingItem.kadmCode;
  }

  get kfsrCode(): string {
    return this._financingItem.kfsrCode;
  }

  get kcsrCode(): string {
    return this._financingItem.kcsrCode;
  }

  get kvrCode(): string {
    return this._financingItem.kvrCode;
  }

  get kosguCode(): string {
    return this._financingItem.kosguCode;
  }

  get dopFkCode(): string {
    return this._financingItem.dopFkCode;
  }

  get dopEkCode(): string {
    return this._financingItem.dopEkCode;
  }

  get dopKrCode(): string {
    return this._financingItem.dopKrCode;
  }

  get code(): string {
    return this._activityVersion.activity.code;
  }

  get shortName(): string {
    return this._activityVersion.activity.shortName;
  }

  get versionCode(): string {
    return this._activityVersion.code;
  }

  get curatorId(): number {
    return this.activityVersion.activity.curatorId;
  }

  get redistributionSum(): number {
    return this._redistributionSum;
  }

  set redistributionSum(value: number) {
    this._redistributionSum = value;
  }

  get activityFinancingFinishSum(): number {
    return this._activityFinancingFinishSum;
  }

  set year(value: number) {
    this._year = value;
  }

  set activityFinancingCanRedistribute(value: number) {
    this._activityFinancingCanRedistribute = value;
  }

  set activityFinancingRedistributeReserve(value: number) {
    this._activityFinancingRedistributeReserve = value;
  }

  set activityFinancingSum(value: number) {
    this._activityFinancingSum = value;
  }

  set activityFinancingFinishSum(value: number) {
    this._activityFinancingFinishSum = value;
  }

  set financingItem(value: PitFinancingItem) {
    this._financingItem = value;
  }

  set activityVersion(value: PitSourceActivityVersion) {
    this._activityVersion = value;
  }

  equalsToSource(el: PitFinancingRedistributionBySource): boolean {
    return this.activityVersion.id === el.activityVersion.id && this.financingItemSrcId === el.financingItemSrcId;
  }

}
